import React, { useState } from 'react';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert
} from 'reactstrap';
import { connect } from 'react-redux';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { answerParentQuery } from '../../api/parentQuery';

const AnswerModal = ({ isOpen, handleClose, queryData, setSuccessAlert, handleRefresh }) => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitError, setSubmitError] = useState({ show: false, message: '' });
  const handleAnswerQuery = async (event, data) => {
    try {
      setSubmitLoading(true);
      await answerParentQuery(queryData._id, data);
      setSuccessAlert({
        show: true,
        message: 'Answered the query successfully'
      });
      handleClose();
      handleRefresh()
    } catch (error) {
      console.error('Failed to answer query: ', error);
      setSubmitError({
        show: true,
        message:
          error?.response?.data?.error || error?.message || 'Failed to answer'
      });
    } finally {
      setSubmitLoading(false);
    }
  };
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} backdrop="static" size="lg">
        <ModalHeader toggle={handleClose}>Answer Query</ModalHeader>
        <ModalBody>
          {submitError.show && (
            <Alert
              color="danger"
              role="alert"
              isOpen={submitError.show}
              toggle={() => setSubmitError({ show: false, message: '' })}
            >
              <i className="mdi mdi-block-helper mr-2"></i>
              {submitError.message}
            </Alert>
          )}
          <AvForm
            className="needs-validation"
            onValidSubmit={handleAnswerQuery}
          >
            <Row>
              <Col md="12">
                <FormGroup>
                  <Label>Query</Label>
                  <AvField
                    name="query"
                    type="text"
                    className="form-control"
                    defaultValue={queryData?.query}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: 'Query is required'
                      }
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md="12">
                <FormGroup>
                  <Label>Answer</Label>
                  <AvField
                    name="answer"
                    type="textarea"
                    className="form-control"
                    defaultValue={queryData?.answer}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: 'Answer is required'
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              <Col>
                <ModalFooter>
                  <Button
                    disabled={submitLoading}
                    type="button"
                    color="light"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    color="success"
                    disabled={submitLoading}
                  >
                    {submitLoading ? 'Saving...' : 'Save'}
                  </Button>
                </ModalFooter>
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(AnswerModal);
